import React from "react";

export const Table2 = ({ output, keys }) => {
  const index = keys.indexOf("FORM-CTOR");
  if (index !== -1) {
    const i = keys.indexOf("DATA-SPECS");
    i !== -1 && keys.splice(i, 1);
  }
  return (
    <>
      <table align="center" width="85%" border="1px" key={"table-1"}>
        <thead key={"thead-1"}>
          <tr align="center" border="1px" key={"tr-1"}>
            {keys.map((item, index) => (
              <th key={`th-${index}`}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody key={"tbody-1"}>
          {output.map((item, index) => {
            return (
              <tr align="center" key={`tr-1.${index}`}>
                {keys.map((key, i) => {
                  return <td key={`td-${i}`}>{item[key] === null ? "null" : item[key].toString()}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};


const Table = ({ columns, rows }) => {
  const index = columns.indexOf("FORM-CTOR");
  if (index !== -1) {
    const i = columns.indexOf("DATA-SPECS");
    i !== -1 && columns.splice(i, 1);
  }

  // 1. Calcular el ancho de cada columna (máximo entre título y contenido)
  const columnWidths = columns.map(col => {
    const headerWidth = col.length;
    const maxCellWidth = Math.max(...rows.map(row => (row[col]?.toString().length || 0)));
    return Math.max(headerWidth, maxCellWidth);
  });

  // 2. Generar una fila horizontal (e.g. +----+------+)
  const horizontalLine = '+' + columnWidths.map(w => '-'.repeat(w + 2)).join('+') + '+';

  // 3. Crear una fila con contenido (e.g. | 1  | Bob  |)
  const formatRow = (rowData) => {
    return '| ' + columns.map((col, i) => {
      const cell = rowData[col]?.toString() || '';
      return cell.padEnd(columnWidths[i]) + ' ';
    }).join('| ') + '|';
  };

  // 4. Crear el cuerpo completo de la tabla
  const tableString = [
    horizontalLine,
    formatRow(Object.fromEntries(columns.map((col, i) => [col, col.toUpperCase()]))),
    horizontalLine,
    ...rows.map(row => formatRow(row)),
    horizontalLine
  ].join('\n');

  return (
    <pre style={{ fontFamily: 'monospace', whiteSpace: 'pre', color: "white" }}>
      {tableString}
    </pre>
  );
};


export default Table;
